<div plyr class="player" plyrTitle="Lot Video" [plyrPlaysInline]="true" [plyrSources]="videoSources" [plyrOptions]="plyrOptions" (plyrInit)="player = $event"></div>
